import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "7.5",
      fill: "#522BD6",
      stroke: "#522BD6",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.66683 10L9.16683 12.5L13.3335 7.5",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }